// import store from "@/store.js"

export default class TextDiff {
    constructor(data, cmsPage, language) {
        this.id = data.id;
        this.component = cmsPage.findComponent(this.id);
        this.original = data.content || null;
        if (this.component) {
            this.original = this.component.getText(language);
        }
        this.suggestion = data.newContent || data.improvedContent;// compatibility
        this.comparison = data.comparison;
        this.status = this.original === this.suggestion ? `identical` : `different`;
    }
}
